import { render, staticRenderFns } from "./CPanel.vue?vue&type=template&id=c1d63c52&scoped=true&"
import script from "./CPanel.vue?vue&type=script&lang=js&"
export * from "./CPanel.vue?vue&type=script&lang=js&"
import style0 from "./CPanel.vue?vue&type=style&index=0&id=c1d63c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d63c52",
  null
  
)

export default component.exports